import ApiVolumes from '../../api/volumestrims';

const getFueltypesStarted = () => ({
    type: 'GET_FUELTYPES_STARTED'
});

const getFueltypesSuccess = items => ({
    type: 'GET_FUELTYPES_SUCCESS',
    payload: items
});

const getFueltypesFailure = error => ({
    type: 'GET_FUELTYPES_FAILURE',
    payload: { error }
});

const getFueltypes = () => {

    return dispatch => {

        dispatch(getFueltypesStarted());

        ApiVolumes.getFueltypes()
            .then(json => { 
                const items = json.fueltypes;
                dispatch(getFueltypesSuccess({ items }));
            })
            .catch(error => dispatch(getFueltypesFailure(error)));            

    }
    
}

export default { getFueltypes }